const TTL = parseInt(process.env.REACT_APP_CACHE_TTL) || 300000;

export const cacheGet = (key) => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;
    const { data, timestamp } = JSON.parse(item);
    if (Date.now() - timestamp > TTL) {
      localStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

export const cacheSet = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
  } catch {
    // localStorage lleno — continuar sin cache
  }
};

export const cacheInvalidate = (key) => {
  localStorage.removeItem(key);
};

// Clave para la base de productos editada desde el admin
export const PRODUCTS_CACHE_KEY = 'ml_products_db';
// Clave para posts del blog
export const BLOG_POSTS_KEY = 'ml_blog_posts';
